import { Outlet, BrowserRouter as Router } from 'react-router-dom';
// import Footer from "./component/Footer/footer";
// import Navbar from './component/Navbar/navbar';
import AppRoutes from './router/AppRoutes';
import { ToastContainer, toast } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
function App() {
  return (
    <div className="App font-poppins">
      <Router>
        <AuthProvider>
          <AppRoutes />
          <ToastContainer />
          <Outlet/>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;